import React, { useContext, useEffect } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Modify } from 'utils/types';
import { dateHelper } from 'utils/helper';
import { AuthContext } from 'Contexts/AuthContext';
import useAppActivation from 'CustomHooks/useAppActivation';
import VisitWishList from './VisitWishList';

export type VisitWishesContainerProps = Modify<
  RouteComponentProps,
  { match: { params: { restaurantId: string } } }
>;

// The screen belongs to the "Besuchswünsche" app. Until the restaurant's own
// app list is known nothing is shown or requested; without the app a direct
// link leads to the table plan. The router keeps the screen mounted across
// restaurants: a new restaurant starts with nothing loaded, so no setting or
// action of the previous one is shown or sent until its own answer arrived.
const VisitWishesContainer = ({ match }: VisitWishesContainerProps) => {
  const { restaurantId } = match.params;
  const { setrestaurantId } = useContext(AuthContext);
  const activation = useAppActivation('visit_wishes', restaurantId);

  useEffect(() => {
    setrestaurantId(restaurantId);
  }, [restaurantId, setrestaurantId]);

  if (activation === 'inactive') {
    return <Redirect to={`/${restaurantId}/reservations/${dateHelper()}/tablePlan`} />;
  }
  if (activation === 'loading') return null;
  return <VisitWishList key={restaurantId} restaurantId={restaurantId} />;
};

export default VisitWishesContainer;
